module.exports = __webpack_public_path__ + "img/documento.281fec38.svg";